import { Subscription, interval } from 'rxjs';
import { DriveWorkspaceState } from './drive-viewer.state';

export class DriveAutosyncCoordinator {
  private subscription?: Subscription;
  private inFlight = false;

  constructor(
    private readonly workspace: DriveWorkspaceState,
    private readonly refresh: (silent: boolean, finished: () => void) => void,
    private readonly isPaused: () => boolean = () => false
  ) {}

  start(): void {
    if (this.subscription) return;
    this.subscription = interval(30000).subscribe(() => {
      if (!this.workspace.active
        || (typeof document !== 'undefined' && document.hidden)
        || this.inFlight
        || this.isPaused()) {
        return;
      }
      this.inFlight = true;
      this.refresh(true, () => { this.inFlight = false; });
    });
  }

  stop(): void {
    this.subscription?.unsubscribe();
    this.subscription = undefined;
    this.inFlight = false;
  }
}
